export default __webpack_public_path__ + "static/media/main.c4b26119.jpeg";